// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorPage_wrapper__ZaT5I","title":"ErrorPage_title__FXOAd"};